export const F_BLOGGER_OUT_RECORDS = 'f_blogger_out_records'